<template>
  <div class="areaselect">
    <!-- 已选区域提示 -->
    <!-- <div class="tips">{{ tips }}</div> -->
    <!-- 下拉选择区域 -->
    <div class="select-options" @click="handleDownAreaStatus('downicon')">
      <div class="select_left">{{ area ? area : '右岸电厂' }}</div>
      <!-- 下拉icon -->
      <div class="down-select">
        <span class="downicon" ref="downicon"></span>
      </div>
    </div>
    <!-- 下拉显示区域 -->
    <el-collapse-transition>
      <ul class="down-aren" v-if="downAreaStatus == 'downicon'">
        <li class="item" v-for="(ele, ind) in cityLevel" :key="ind" @click="handleSelected(ele)">
          {{ ele.name }}
        </li>
      </ul>
    </el-collapse-transition>
    <!-- 下拉选择区域-区 -->
    <div class="select-options" @click="handleDownAreaStatus('downicon2')">
      <div class="select_left">{{ district }}</div>
      <div class="down-select">
        <span class="downicon" ref="downicon2"></span>
      </div>
    </div>
    <!-- 下拉显示区域 -->
    <el-collapse-transition>
      <ul style="position: absolute; top: 30px; left: 179px" class="down-aren" v-if="downAreaStatus == 'downicon2'">
        <li class="item" v-for="(ele, ind) in districtData" :key="ind" @click="DistrictLevel(ele)">
          {{ ele.name }}
        </li>
      </ul>
    </el-collapse-transition>
    <!-- 下拉选择区域-街道 -->
    <div
      v-if="spaceLevel == 'ShenZhenL2' || spaceLevel == 'ShenZhenL3'"
      class="select-options"
      @click="handleDownAreaStatus('downicon3')">
      <div class="select_left">{{ street }}</div>
      <div class="down-select">
        <span class="downicon" ref="downicon3"></span>
      </div>
    </div>
    <!-- 下拉显示区域 -->
    <el-collapse-transition>
      <ul style="position: absolute; top: 30px; left: 347px" class="down-aren" v-if="downAreaStatus == 'downicon3'">
        <li class="item" v-for="(ele, ind) in streetData" :key="ind" @click="streetLevel(ele)">
          {{ ele.name }}
        </li>
      </ul>
    </el-collapse-transition>
  </div>
</template>

<script>
import CameraList from '../../utils/configs/cameraList';
import { mapState } from 'vuex';
export default {
  name: 'areaselect',
  props: {
    TriggerReturn: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['topic', 'cameraInfo', 'spaceLevel'])
  },
  data() {
    return {
      tips: 'Selected Area:',
      area: '',
      district: '机组',
      districtType: '',
      street: 'Street',
      streetType: '',
      downAreaStatus: '', // 下拉列表区域默认不显示
      selectedShowStatus: false, // 选中展示显示状态
      cityLevel: [
        { text: '右岸电厂', name: '右岸电厂', type: '市' },
        { text: '左岸电厂', name: '左岸电厂', type: '市' }
      ],
      districtData: [
        { text: '5号机组', name: '5号机组', type: '南山区' },
        { text: '6号机组', name: '6号机组', type: '南山区' },
        { text: '7号机组', name: '7号机组', type: '南山区' },
        { text: '8号机组', name: '8号机组', type: '南山区' }
      ],
      streetData: [
        { text: '粤海街道', name: 'Yuehai Street', type: '粤海街道' },
        { text: '南山街道', name: 'Nanshan Street', type: '粤海街道' },
        { text: '南头街道', name: 'Nantou Street', type: '粤海街道' },
        { text: '西丽街道', name: 'Xili Street', type: '粤海街道' },
        { text: '沙河街道', name: 'Shahe Street', type: '粤海街道' },
        { text: '蛇口街道', name: 'Shekou Street', type: '粤海街道' },
        { text: '招商街道', name: 'Zhaoshang Street', type: '粤海街道' },
        { text: '桃源街道', name: 'Taoyuan Street', type: '粤海街道' }
      ],
      routerInfo: null
    };
  },
  watch: {
    topic(newV, oldV) {
      if (newV != oldV) this.selectedShowStatus = '';
    },

    spaceLevel: {
      handler(val) {
        switch (val) {
          case 'ShenZhenL0':
            if (this.routerInfo.cname == '城市治理') {
              this.district = '机组';
              this.street = 'Street';
              this.districtType = '';
            }
            break;
          case 'ShenZhenL2':
            if (this.routerInfo.cname == '城市治理') {
              this.district = 'Nanshan District';
              this.street = 'Street';
              this.districtType = '南山区';
            }
            break;
          case 'ShenZhenL3':
            if (this.routerInfo.cname == '城市治理') {
              this.district = 'Nanshan District';
              this.street = 'Yuehai Street';
              this.districtType = '南山区';
            }
          case 'ShenZhenL4':
            if (this.routerInfo.cname == '智慧管廊') {
              this.district = 'Nanshan District';
              this.street = 'Yuehai Street';
              this.districtType = '南山区';
            }
            break;
          default:
            break;
        }
      },
      deep: true
    },

    TriggerReturn: {
      handler(val) {},
      deep: true
    },

    $route: {
      handler(to, from) {
        this.downAreaStatus = '';
        const { parentLevel, cname } = to.meta;
        this.$set(this, 'routerInfo', to.meta);
        switch (cname) {
          case '城市全景':
            this.district = '机组';
            this.street = 'Street';
            this.districtType = '';
            break;
          case '区域全景':
            this.district = 'Nanshan District';
            this.street = 'Street';
            this.districtType = '南山区';
            break;
          case '城市规划':
            this.district = 'Nanshan District';
            this.street = 'Yuehai Street';
            this.districtType = '南山区';
            break;
          case '城市治理':
            this.district = 'District';
            this.street = 'Street';
            this.districtType = '';
            break;
          case '智慧管廊':
            this.district = 'Nanshan District';
            this.street = 'Yuehai Street';
            this.districtType = '南山区';
            break;
          default:
            break;
        }
      },
      deep: true
    }
  },
  methods: {
    // 处理列表区域显示状态
    handleDownAreaStatus(type) {
      if (this.downAreaStatus == type) {
        this.downAreaStatus = '';
        this.$refs[type].style.transform = 'translate(-4px, 12px) rotate(-45deg)';
      } else {
        this.downAreaStatus = type;
        this.$refs[type].style.transform = 'translate(-4px, 8px) rotate(135deg)';
      }
    },
    // 处理选中状态-市级
    handleSelected(area) {
      this.area = area.text;
      this.district = '机组';
      this.street = 'Street';
      this.downAreaStatus = '';
      this.$refs.downicon.style.transform = 'translate(-4px, 8px) rotate(135deg)';
      this.$store.commit('setHighLight', '设备监测');
    },
    // 处理选中状态-区级
    DistrictLevel(area) {
      if (this.spaceLevel == 'ShenZhenL2') {
        this.district = area.name;
        this.downAreaStatus = '';
        this.$refs.downicon2.style.transform = 'translate(-4px, 8px) rotate(135deg)';
        return;
      }
      this.district = area.name;
      if (this.districtType == area.type) {
        this.street = 'Street';
      } else {
        this.districtType = area.type;
      }

      this.downAreaStatus = '';
      this.$refs.downicon2.style.transform = 'translate(-4px, 8px) rotate(135deg)';
      this.$store.commit('setHighLight', '发电机组');
    },
    // 处理选中状态-街道级
    streetLevel(area) {
      this.street = area.name;
      if (this.routerInfo.cname == '城市治理' || this.routerInfo.cname == '智慧管廊') {
      } else {
        this.routerInfo.sublevel && this.$router.push({ path: this.routerInfo.sublevel });
      }
      this.downAreaStatus = '';
      this.$refs.downicon3.style.transform = 'translate(-4px, 8px) rotate(135deg)';
    }
  }
};
</script>

<style lang="less" scoped>
.areaselect {
  height: 30px;
  display: flex;
  align-items: center;
  position: relative;
  pointer-events: all;
  .tips {
    width: 130px;
    height: 30px;
    line-height: 30px;
    font-family: 'Helvetica';
    font-size: 16px;
    text-align: center;
    color: #e0faff;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-sizing: border-box;
    background-image: linear-gradient(to bottom, rgba(14, 34, 52, 0.8), rgba(14, 34, 52, 0.1));
  }
  .select-options {
    width: 152px;
    height: 30px;
    background: #0d2033;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px #1fbbef solid;
    box-sizing: border-box;
    margin: 0px 5px 0px 11px;
    .select_left {
      width: 138px;
      line-height: 28px;
      font-family: 'Helvetica';
      font-size: 18px;
      color: #e1fbff;
      padding-left: 13px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .down-select {
      width: 14px;
      height: 30px;
      border-left: 1px #1fbbef solid;
      box-sizing: border-box;
      transition: all 0.6s;
      position: relative;
      .downicon {
        position: absolute;
        top: 2px;
        left: 8px;
        border-top: 3px solid #1feaef;
        border-right: 3px solid #1feaef;
        border-left: 3px solid transparent;
        border-bottom: 3px solid transparent;
        transform: translate(-4px, 8px) rotate(135deg);
      }
    }
  }
  .down-aren {
    position: absolute;
    top: 30px;
    left: 10px;
    width: 152px;

    box-sizing: border-box;
    &:nth-of-type(2) {
      top: 30px;
      left: 309px;
    }
    &:nth-of-type(3) {
      top: 30px;
      left: 477px;
    }
    & li.item {
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-family: 'Helvetica';
      font-size: 16px;
      color: #e0faff;
      background: rgba(#0d2033, 0.8);
      user-select: none;
      &:not(:first-of-type) {
        border-top: none;
      }
      &:hover {
        color: #00ffff;
        background: rgba(#1fbbef, 0.7);
      }
    }
  }
  .selected-area {
    position: relative;
    width: 140px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-family: 'Helvetica';
    font-size: 16px;
    color: #e0faff;
    border: 1px #1fbbef solid;
    box-sizing: border-box;
    background: rgba(31, 187, 239, 0.2);

    &::before {
      position: absolute;
      left: -10px;
      display: inline-block;
      content: '';
      border-top: 4px solid #fff;
      border-right: 4px solid #fff;
      border-left: 4px solid transparent;
      border-bottom: 4px solid transparent;
      transform: translate(-4px, 10px) rotate(45deg);
    }
  }
}
</style>
